import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { AddTitle, GetSelectTitle, GetTitleList } from "./title.classes";

export interface TitleModel {
  /** 法人識別コード */
  corpcd?: string;

  /** 事業所識別コード */
  officecd?: string;

  /** ブロック識別コード */
  blockcd?: string;

  /** 予備コード */
  subcd?: string;

  /** ユニット識別コード */
  unitcd?: string;

  /** タイトル区分ID */
  ttlkbn?: string;

  /** タイトルID */
  ttlcd?: string;

  /** 有効期限 (開始) */
  sdate?: string;

  /** 有効期限 (終了) */
  edate?: string;

  /** 記録対象区分コード */
  objkbn?: string;

  /** タイトル略称 */
  ttlsnm?: string;

  /** タイトル名称 */
  ttlnm?: string;

  /** タイトル名称 (長い表示用) */
  ttllnm?: string;

  /** タイトル説明 */
  ttlnote?: string;

  /** モバイルカーデックス番号 */
  pdano?: number;

  /** モバイル入力形式デフォルト */
  pdainput?: number;

  /** タイトル構造フィールド */
  ttlstruct?: string;

  /** 関連記録タイトルフィールド */
  relation?: string;

  /** 定時時間 */
  tsv?: string;

  /** 領域データ */
  area?: string;

  /** コンポジションフラグ */
  composition?: number;

  /** 記録種別 デフォルト値 */
  notekbn?: number;

  /** 文書種別 デフォルト値 */
  dockbn?: number;

  /** スケジュール種別属性 */
  schedtype?: number;

  /** スケジュール属性 デフォルト値 */
  schedatr?: number;

  /** 結果種別 デフォルト値 */
  resultatr?: number;

  /** 立案属性 デフォルト値 */
  draftatr?: number;

  /** 日誌ピックアップフラグ デフォルト値 */
  pickupflg?: number;

  /** 生涯カルテピックアップフラグ デフォルト値 */
  lifeflg?: number;

  /** 重要度 デフォルト値 */
  spflg?: number;

  /** 緊急度 デフォルト値 */
  urgflg?: number;

  /** 読込権限属性 デフォルト値 */
  r?: number;

  /** 書込権限属性 デフォルト値 */
  w?: number;

  /** 実行権限属性 デフォルト値 */
  x?: number;

  /** マスタ登録日 */
  regdate?: Date;

  /** 最終更新日 */
  koshin?: Date;

  /** 削除フラグ */
  delflg?: number;

  /** ソート番号 */
  sortno?: number;

  /** 製作者コード */
  insstfcd?: string;

  /** 製作日時 */
  insdate?: Date;

  /** 更新者コード */
  updstfcd?: string;

  /** 更新日時 */
  upddate?: string;

  /** Help URL */
  helpurl?: string;

  /** Ntitle */
  ntitle?: string;
}

export interface TitleMaster {
  titleList: TitleModel[];
}

export interface TitleFetchCondition {
  ttlkbn?: string;
  ttlcd?: string;
  sdate?: string;
  corpcd?: string;
  officecd?: string;
  blockcd?: string;
  subcd?: string;
  unitcd?: string;
}

@State<TitleMaster>({
  name: 'title',
  defaults: {
    titleList: []
  }
})

@Injectable()
export class TitleState {
  constructor() { }
  @Action(GetSelectTitle)
  getTitle(
    ctx: StateContext<TitleMaster>,
    { ttlkbn, ttlcd }: GetSelectTitle
  ) {
    return ctx.getState()?.titleList?.find(x => x.ttlkbn === ttlkbn && x.ttlcd === ttlcd);
  }

  //   @Action(FetchTitle)
  //   async fetchTitle(
  //     ctx: StateContext<TitleMaster>,
  //     { condition, checkExist }: FetchTitle
  //   ) {
  // // 
  //   }

  @Action(AddTitle)
  addTitle(
    ctx: StateContext<TitleMaster>,
    { title }: AddTitle
  ) {
    let list = { ...ctx.getState() };
    if (list.titleList.length === 0) {
      ctx.patchState({ titleList: [title] });
      return;
    } else {
      let { titleList } = list;
      if (!titleList.some(x => x.ttlkbn === title.ttlkbn && x.ttlcd === title.ttlcd)) {
        ctx.patchState({ titleList: [...titleList, title] });
      }
    }
  }

  @Action(GetTitleList)
  getListTitle(
    ctx: StateContext<TitleMaster>
  ) {
    return ctx.getState().titleList;
  }

}
